import { render, staticRenderFns } from "./JudgingShortcut.vue?vue&type=template&id=6d4f7579&scoped=true"
import script from "./JudgingShortcut.vue?vue&type=script&lang=js"
export * from "./JudgingShortcut.vue?vue&type=script&lang=js"
import style0 from "./JudgingShortcut.vue?vue&type=style&index=0&id=6d4f7579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f7579",
  null
  
)

export default component.exports